export default __webpack_public_path__ + "static/media/loader_11_d.ea2c6a9b.png";